/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Symbol, Typography } from '@doveit/lego';
import Link from 'next/link';
import React from 'react';
import Image from 'next/image';
import { requireFromStaticAsset } from '../../utils/assetsUtils';
import { goToPage, URLObject } from '../../utils/links';
import * as styles from './AgentCard.style';
import { DOVE_IT_PICTOGRAM } from '../../themes/icons';
import { Asset } from '../../../domain/graphcms';

export interface AgentCardProps {
  name: string,
  jobTitle: string,
  picture?: Asset,
  franchising?: boolean,
  urlObject?: URLObject,
  locality?: string,
}

const AgentCard: React.FC<AgentCardProps> = ({
  name,
  jobTitle,
  picture,
  urlObject,
  locality,
  franchising = false,
}) => {
  const onClick = React.useCallback(
    () => urlObject && goToPage(urlObject),
    [urlObject],
  );

  return (
    <article
      data-ref="agent-card"
      css={styles.base}
      onClick={urlObject && onClick}
    >
      <div css={styles.picture}>
        {picture ? (
          <Image
            src={picture.url}
            alt={`${name} Agente Immobiliare${locality ? ` a ${locality}` : ''}`}
            width="52"
            height="52"
          />
        ) : (
          <Image
            src={requireFromStaticAsset('agents/agent-placeholder.svg')}
            alt={`${name} Agente Immobiliare${locality ? ` a ${locality}` : ''}`}
            width="52"
            height="52"
          />
        )}
      </div>
      <div css={styles.info}>
        <Typography.BODY>
          {urlObject ? (
            <Link
              href={urlObject.url}
              as={urlObject.as}
            >
              {name}
            </Link>
          ) : name}
        </Typography.BODY>
        <div css={styles.details}>
          {!franchising && (
            <Symbol
              path={DOVE_IT_PICTOGRAM}
              size={18}
            />
          )}
          <span>{jobTitle}</span>
        </div>
      </div>
    </article>
  );
};

export default AgentCard;
